export const LEGAL_EFFECTIVE_DATE = 'July 31, 2026';
export const CURRENT_TERMS_VERSION = 'scrubplan-terms-2026-07-31';

export const TERMS_ROUTE = '/termsconditions';
export const PRIVACY_ROUTE = '/privacypolicy';

export const TERMS_ACCEPTANCE_STORAGE_KEY = 'TERMS_CONDITIONS';
export const TERMS_ACCEPTANCE_VERSION_STORAGE_KEY = 'TERMS_CONDITIONS_VERSION';

const publicAssetRoot = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const legalAssetRoot = `${publicAssetRoot}/legal/2026-07-31`;

export interface LegalDocumentMetadata {
	assetUrl: string;
	downloadFileName: string;
	effectiveDate: string;
	kind: 'terms' | 'privacy';
	route: string;
	title: string;
	version: string;
}

export const TERMS_DOCUMENT: LegalDocumentMetadata = {
	assetUrl: `${legalAssetRoot}/ScrubPlan-Software-Agreement-Twilio-Compliant-2026-07-31.pdf`,
	downloadFileName: 'ScrubPlan-Software-Agreement-Twilio-Compliant-2026-07-31.pdf',
	effectiveDate: LEGAL_EFFECTIVE_DATE,
	kind: 'terms',
	route: TERMS_ROUTE,
	title: 'Terms & Conditions',
	version: CURRENT_TERMS_VERSION,
};

export const PRIVACY_DOCUMENT: LegalDocumentMetadata = {
	assetUrl: `${legalAssetRoot}/ScrubPlan-Privacy-Policy-Twilio-Compliant-2026-07-31.pdf`,
	downloadFileName: 'ScrubPlan-Privacy-Policy-Twilio-Compliant-2026-07-31.pdf',
	effectiveDate: LEGAL_EFFECTIVE_DATE,
	kind: 'privacy',
	route: PRIVACY_ROUTE,
	title: 'Privacy Policy',
	version: 'scrubplan-privacy-2026-07-31',
};

const serverAccepted = (value: unknown) => value === true || value === 'true';

export const syncTermsAcceptanceFromServer = (value: unknown, storage: Storage = localStorage) => {
	const accepted = serverAccepted(value);
	storage.setItem(TERMS_ACCEPTANCE_STORAGE_KEY, String(accepted));
	if (accepted) {
		// Account acceptance is authoritative. Sign-out clears browser storage, so
		// restore the UI marker from the persisted user flag on the next login.
		storage.setItem(TERMS_ACCEPTANCE_VERSION_STORAGE_KEY, CURRENT_TERMS_VERSION);
	} else {
		storage.removeItem(TERMS_ACCEPTANCE_VERSION_STORAGE_KEY);
	}
	return accepted;
};

export const isCurrentTermsAccepted = (storage: Storage = localStorage) =>
	storage.getItem(TERMS_ACCEPTANCE_STORAGE_KEY) === 'true';

export const recordCurrentTermsAcceptance = (storage: Storage = localStorage) => {
	storage.setItem(TERMS_ACCEPTANCE_STORAGE_KEY, 'true');
	storage.setItem(TERMS_ACCEPTANCE_VERSION_STORAGE_KEY, CURRENT_TERMS_VERSION);
};

const SHARED_TERMS_ACCEPTANCE_STORAGE_PREFIX = 'CHANGE_LOG_SHARED_TERMS_ACCEPTED';

export const getSharedTermsAcceptanceStorageKey = (token: string) =>
	`${SHARED_TERMS_ACCEPTANCE_STORAGE_PREFIX}:${token}`;

export const isSharedTermsAccepted = (token: string, storage: Storage = localStorage) =>
	storage.getItem(getSharedTermsAcceptanceStorageKey(token)) === CURRENT_TERMS_VERSION;

export const recordSharedTermsAcceptance = (token: string, storage: Storage = localStorage) => {
	storage.setItem(getSharedTermsAcceptanceStorageKey(token), CURRENT_TERMS_VERSION);
};
